import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogConfiguration } from '../interfaces/dialog-configuration.interface';

@Component({
  selector: 'app-request-information',
  templateUrl: './request-information.component.html',
  styleUrls: ['./request-information.component.scss'],
})
export class RequestInformationComponent {
  public configuration: DialogConfiguration;
  public updatePrice = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogConfiguration,
    public dialogReference: MatDialogRef<RequestInformationComponent>
  ) {
    this.configuration = {
      title: data.title,
      question: data.question,
    };
  }

  close() {
    this.dialogReference.close();
  }
}
